import TrainingSideBar from './TrainingSideBar';

export default TrainingSideBar;